import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useLang } from "@/i18n";
import { Shell } from "@/components/Shell";
import { ChipGroup } from "@/components/fields";
import { EXPENSE_CATEGORIES, PAYMENT_METHOD, label } from "@/constants";
import { money } from "@/lib/format";
import { toast } from "sonner";
import { CaretLeft } from "@phosphor-icons/react";

export default function Expenses() {
  const { lang, t } = useLang();
  const nav = useNavigate();
  const [list, setList] = useState([]);
  const [cat, setCat] = useState("Travel");
  const [catOptions, setCatOptions] = useState(EXPENSE_CATEGORIES);
  const [amount, setAmount] = useState("");
  const [mode, setMode] = useState("cash");
  const [remark, setRemark] = useState("");

  const load = () => api.get("/expenses", { params: { date: new Date().toISOString().slice(0, 10) } }).then(({ data }) => setList(data));
  useEffect(() => {
    load();
    api.get("/options", { params: { type: "expense_category" } })
      .then(({ data }) => { if (data.length) { setCatOptions(data.map((o) => ({ value: o.label, en: o.label, hi: o.label_hi }))); setCat(data[0].label); } })
      .catch(() => {});
  }, []);

  const add = async () => {
    if (!amount) return;
    await api.post("/expenses", { category: cat, amount: Number(amount), payment_mode: mode, remark });
    setAmount(""); setRemark("");
    toast.success(t("add_expense"));
    load();
  };
  const total = list.reduce((s, e) => s + Number(e.amount), 0);

  return (
    <Shell title={t("expenses")}
      back={<button onClick={() => nav("/")} data-testid="back-btn"><CaretLeft size={22} /></button>}>
      <div className="space-y-4">
        <div className="rounded-xl bg-white border border-slate-200 p-4 space-y-3">
          <ChipGroup options={catOptions} value={cat} onChange={setCat} testid="expense-category" />
          <input data-testid="expense-amount" value={amount} onChange={(e) => setAmount(e.target.value)} inputMode="numeric" placeholder={t("amount")} className="w-full min-h-[48px] rounded-lg border border-slate-200 px-3" />
          <ChipGroup options={PAYMENT_METHOD} value={mode} onChange={setMode} testid="expense-mode" />
          <input data-testid="expense-remark" value={remark} onChange={(e) => setRemark(e.target.value)} placeholder={t("remarks")} className="w-full min-h-[48px] rounded-lg border border-slate-200 px-3" />
          <button onClick={add} data-testid="add-expense-btn" className="w-full min-h-[48px] rounded-lg bg-emerald-600 text-white font-semibold">{t("add_expense")}</button>
        </div>

        <div className="flex justify-between items-center rounded-xl bg-slate-800 text-white p-4">
          <span className="text-sm">{t("daily_total")}</span>
          <span className="font-head font-bold text-xl" data-testid="expense-total">{money(total)}</span>
        </div>

        <div className="space-y-2">
          {list.map((e) => (
            <div key={e.id} className="flex items-center justify-between rounded-lg bg-white border border-slate-200 p-3" data-testid={`expense-item-${e.id}`}>
              <div>
                <p className="font-semibold text-slate-800 text-sm">{e.category}</p>
                <p className="text-xs text-slate-500">{e.payment_mode} {e.remark && `· ${e.remark}`}</p>
              </div>
              <div className="text-right">
                <p className="font-semibold">{money(e.amount)}</p>
                {e.needs_approval && <span className="text-[10px] text-amber-600 font-bold">{t("needs_approval")}</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Shell>
  );
}
